import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/*登录、入口、404页面等*/
import building from '@/components/building'		// 404
import team from '@/components/team/index'			// 团队
import personal from '@/components/personal/home'	// 个人

/*分板块-子路由*/
import route_personal from '@/router/personal'
import route_team from '@/router/team'


export default new Router({
	routes: [
	    {
	    	path: '*',
		    name: '404',
		    component: building,
		    meta:{
		    	title: '404',
		    	notNeedlogin: true
		    }
	    },
	    {
	    	path: '/',
		    name: 'personal',
	    	redirect: '/personal',
		    component: personal,
		    meta:{
		    	title: 'personal'
		    }
	    },
	    {
	    	path: '/team',
	    	name: 'team',
	    	redirect: '/team/order',
	    	component: team,
	    	meta:{
	    		title: '团体预约'
	    	},
	    	children:[
	    		...route_team
	    	]
	    },
	    {
	    	path: '/personal',
	    	name: 'personal',
	    	redirect: '/personal/index',
	    	component: personal,
	    	meta:{
	    		title: '个人预约'
	    	},
	    	children:[
	    		...route_personal
	    	]
	    }
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js